var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("rect",{"x":"-2.2","y":"6","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 6.5002 -2.6924)","width":"17.4","height":"0.9"})),React.createElement("g",{"key":1},React.createElement("rect",{"x":"6","y":"-2.2","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 6.5 -2.6924)","width":"0.9","height":"17.4"}))]));
}

Close.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"13px","height":"13px","viewBox":"0 0 13 13","enableBackground":"new 0 0 13 13","xmlSpace":"preserve"};

module.exports = Close;

Close.default = Close;
